"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var core_1 = require("../../core");
var buffer_1 = require("buffer");
var logger_1 = require("../../logger");
var logger = logger_1.default('Relay');
var RelayServer = /** @class */ (function () {
    function RelayServer(_server, params) {
        this._server = _server;
        this._params = params || {
            port: 2000
        };
        this._clients = [];
    }
    Object.defineProperty(RelayServer.prototype, "server", {
        get: function () {
            return this._server;
        },
        enumerable: true,
        configurable: true
    });
    RelayServer.prototype.addClient = function (socket) {
        this._clients.push(socket);
        return this;
    };
    RelayServer.prototype.removeClient = function (client) {
        var index = this._clients.indexOf(client);
        if (index >= 0) {
            client.close();
            logger.debug("Removing client " + client.getClientName() + "...");
            delete this._clients[index];
        }
        return this;
    };
    RelayServer.prototype.start = function () {
        var _this = this;
        this._subscription = new rxjs_1.Subject();
        this._server
            .connections()
            .subscribe(function (socket) { return __awaiter(_this, void 0, void 0, function () {
            var clientName;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clientName = socket.getClientName();
                        logger.log("[NEW_CLIENT] " + clientName);
                        return [4 /*yield*/, socket.ready()];
                    case 1:
                        _a.sent();
                        logger.log("[NEW_CLIENT] " + clientName + " IS READY");
                        // Put this new client in the list
                        this.addClient(socket);
                        socket
                            .events()
                            .subscribe({
                            next: function (event) {
                                switch (event.type) {
                                    case 'data':
                                        var messageString = _this.messageToLog(event.payload);
                                        logger.log("[MESSAGE] " + messageString + " from " + clientName);
                                        _this.broadcastMessage(event.payload, socket);
                                        break;
                                    case 'error':
                                        logger.error("[ERROR] " + clientName + " ", event.payload);
                                        // Do we have to remove client every time ? 
                                        _this.removeClient(socket);
                                        break;
                                    case 'end':
                                        logger.log("[CLIENTEND] " + clientName);
                                        _this.removeClient(socket);
                                        break;
                                }
                            }
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        return this._server.listen(this._params);
    };
    RelayServer.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._clients.forEach(function (client) {
                            client.close();
                        });
                        if (!this._server) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._server.stop()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this._subscription) {
                            this._subscription.complete();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RelayServer.prototype.broadcastMessage = function (message, sender) {
        var messageString = this.messageToLog(message);
        logger.log("[BROADCAST] " + messageString + " from " + sender.getClientName());
        if (this._clients.length == 0) {
            logger.warn("There is no client yet");
            return;
        }
        // Send a message to all clients
        this._clients.forEach(function (client) {
            // Don't want to send it to sender
            try {
                if (client === sender) {
                    logger.debug("\t- Skip sender " + client.getClientName());
                    return;
                }
                if (client.isWritable()) {
                    logger.log("\t- Sent to " + client.getClientName());
                    client.write(message);
                }
                else {
                    logger.warn("Client " + client.getClientName() + " is not writable. Cannot send to it");
                }
            }
            catch (err) {
                logger.error("Cannot broadcast to " + client.getClientName(), err);
            }
        });
    };
    RelayServer.prototype.messageToLog = function (message) {
        if (typeof message === "string") {
            return "\"" + message + "\"";
        }
        else if (message instanceof buffer_1.Buffer) {
            return core_1.FormatHelper.toHexString(message);
        }
        else {
            return message;
        }
    };
    return RelayServer;
}());
exports.RelayServer = RelayServer;
